<!-- App.vue -->
<template>
  <div id="app">
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Generar fechas y horarios</h4>
    <hr>
    <label for="year">Seleccione el año:</label>
    <select v-model="selectedYear" @change="createRecords">
      <option :value="null" disabled>Seleccione año</option>
      <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
    </select>
    <div v-for="company in companies" :key="company.idEmpresa">
      <h2>{{ company.nombreEmpresa }}</h2>
      <p>Registros creados para {{ selectedYear }}:</p>
      <ul>
        <li v-for="record in records[company.idEmpresa]" :key="record.idFechaCita">
          {{ record.fechaReg }}
        </li>
      </ul>
    </div>
    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import api from "@/services/api";
export default {
  components: {
      Layout,
      Footer
    },
  data() {
    return {
      years: [2024], // Puedes ajustar los años según tus necesidades
      selectedYear: null,
      companies: [],
      records: {},
    };
  },
  methods: {
    async createRecords() {
      // Llamada al servicio para obtener la lista de empresas
      const response = await api.get("/vwempresas");
      this.companies = response.data;

      // Crear registros para cada empresa y día del año
      for (const company of this.companies) {
        const recordsForCompany = await this.createRecordsForCompany(company.idEmpresa);
        this.$set(this.records, company.idEmpresa, recordsForCompany);
      }
    },
    async createRecordsForCompany(companyId) {
      const records = [];

      // Crear registros para todos los días del año seleccionado
      for (let day = 1; day <= 365; day++) {
        const date = new Date(`${this.selectedYear}-01-01`);
        date.setDate(day);

        // Llamada al servicio para crear registros de fechas
        const fechaResponse = await api.post("/fechacitas", {
          estado: 1,
          fechaReg: date.toISOString(),
          idFechaCita: 0,
        });

        // Crear registros de horarios para todas las horas laborables
        for (let hour = 8; hour <= 17; hour++) {
          await api.post("/horarios", {
            contador: 0,
            estado: 1,
            horaDesde: `${hour}:00`,
            horaHasta: `${hour + 1}:00`,
            idEmpresa: companyId,
            idFechaCita: fechaResponse.data.idFechaCita,
            idHorario: 0,
          });
        }

        records.push(fechaResponse.data);
      }

      return records;
    },
  },
};
</script>
<!--
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h2 {
  margin-top: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 5px;
}
</style>
-->